import Program from 'wwg-utilities/dist/collections/program';
import apiClient from './axiosClient';

const getProgramsByOnetCodeRequest = async (
  onetCode: string,
  region?: string,
): Promise<Program[]> => {
  return apiClient
    .get(`programs/onet-code/${onetCode}`, { params: { region } })
    .then((res) => res.data);
};

export default getProgramsByOnetCodeRequest;
